import getAPIResponse from './common/Common';

export async function getMe(options = {}) {
  return await getAPIResponse('/api/v1/user/me', {}, 'get', options);
}
